import React, { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem("tulsi_cart");
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });
  const [tableNumber, setTableNumber] = useState(() => localStorage.getItem("tulsi_table") || "");

  useEffect(() => {
    localStorage.setItem("tulsi_cart", JSON.stringify(items));
  }, [items]);

  useEffect(() => {
    if (tableNumber) localStorage.setItem("tulsi_table", tableNumber);
  }, [tableNumber]);

  const addItem = (menuItem) => {
    setItems((prev) => {
      const idx = prev.findIndex((i) => i.menu_item_id === menuItem.id);
      if (idx >= 0) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], quantity: copy[idx].quantity + 1 };
        return copy;
      }
      return [
        ...prev,
        { menu_item_id: menuItem.id, name: menuItem.name, price: menuItem.price, quantity: 1 },
      ];
    });
  };

  const updateQty = (menuItemId, qty) => {
    setItems((prev) =>
      qty <= 0
        ? prev.filter((i) => i.menu_item_id !== menuItemId)
        : prev.map((i) => (i.menu_item_id === menuItemId ? { ...i, quantity: qty } : i))
    );
  };

  const removeItem = (menuItemId) =>
    setItems((prev) => prev.filter((i) => i.menu_item_id !== menuItemId));

  const clear = () => setItems([]);

  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider
      value={{ items, addItem, updateQty, removeItem, clear, subtotal, count, tableNumber, setTableNumber }}
    >
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
